import EditPencilIcon from "@redotech/redo-icons/edit-01.svg";
import {
  CommentState,
  ConversationPlatform,
  ExpandedConversation,
  ExpandedConversationMessage,
} from "@redotech/redo-model/conversation";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { Flex } from "@redotech/redo-web/flex";
import EyeIcon from "@redotech/redo-web/icon-old/eye.svg";
import TrashIcon from "@redotech/redo-web/icon-old/trash.svg";
import { RedoSupportChannelBadge } from "@redotech/redo-web/support/redo-support-channel-badge";
import "quill/dist/quill.snow.css";
import { memo } from "react";

export const MessageBadges = memo(function MessageBadges({
  message,
  conversation,
}: {
  message: ExpandedConversationMessage;
  conversation: ExpandedConversation;
}) {
  const isMetaPlatform = [
    ConversationPlatform.FACEBOOK,
    ConversationPlatform.FACEBOOK_COMMENTS,
    ConversationPlatform.INSTAGRAM,
    ConversationPlatform.INSTAGRAM_COMMENTS,
  ].includes(conversation.platform);

  if (!isMetaPlatform) {
    return null;
  }

  // Check for message state (hidden, deleted, edited)
  const isFacebookComment = message.facebook?.comment;
  const isInstagramComment = message.instagram?.comment;

  const commentState = isFacebookComment
    ? message.facebook?.comment?.state
    : isInstagramComment
      ? message.instagram?.comment?.state
      : null;

  const isDeleted =
    commentState === CommentState.DELETED ||
    (isFacebookComment && message.facebook?.comment?.deleted);

  const isHidden = commentState === CommentState.HIDDEN;

  const isEdited = commentState === CommentState.EDITED;

  return (
    <Flex gap="xs" justify="flex-end">
      <RedoSupportChannelBadge platform={conversation.platform} />

      {isDeleted && (
        <RedoBadge
          color="error"
          segmentLeading={{ type: "icon", Icon: TrashIcon }}
          size="xs"
          text="Deleted"
        />
      )}
      {isHidden && (
        <RedoBadge
          color="gray"
          segmentLeading={{ type: "icon", Icon: EyeIcon }}
          size="xs"
          text="Hidden"
        />
      )}
      {isEdited && (
        <RedoBadge
          color="gray"
          segmentLeading={{ type: "icon", Icon: EditPencilIcon }}
          size="xs"
          text="Edited"
        />
      )}
    </Flex>
  );
});
